module.exports = __webpack_public_path__ + "static/media/Artboard9.271c0170.png";